<template>
  <div>
    <!--class="container" -->
    <br /><br />
    <center>
      <div v-if="address">
        <button class="button" id="btPrint" @click="createPDF()">
          <span>
            <v-icon>mdi-printer</v-icon>&nbsp;&nbsp;{{
              $t("applicant_info_add.click_to_print")
            }}&nbsp;</span
          >
        </button>
      </div>

      <div v-if="!address">
        <button class="button" id="btPrint">
          <span> {{ $t("applicant_info_add.please_fill_to_able_print") }}</span>
        </button>
      </div>

      <br /><br />
      <div v-if="is_student()">
        <v-btn
          class="ml-2 mt-5"
          color="error"
          rounded
          x-large
          to="/applicant_info_additional_undergraduate"
        >
          {{ $t("applicant_info_add.fill_data") }}
        </v-btn>
      </div>
    </center>
    <br /><br />
    <div id="tab">
      <table class="center">
        <tr>
          <td width="15%" rowspan="3" align="center">
            <img src="kmitl_logo3.gif" />
          </td>
          <td colspan="2">
            <strong
              >สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง<br />
              <span class="english-text"
                >(King Mongkut's Institute of Technology Ladkrabang)</span
              ></strong
            >
          </td>
          <td rowspan="4" align="right">
            <table class="sub-table">
              <tr style="line-height: 84px;" align="center">
                <td width="50px">
                  <span class="english-text"> รูปถ่าย 1 นิ้ว </span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            สำนักทะเบียนและบริการการศึกษา
            <span class="english-text">(KMITL Registration and Educational Service Office)</span>
          </td>
        </tr>
        <tr>
          <td colspan="1">
            ใบสมัคร<br />
            <span class="english-text">Application</span>
          </td>
          <td width="50%" align="left">
            วันที่สมัคร : {{ dateFromDBTranslatorTH(created_at) }}<br /><span
              class="english-text"
              >Date of application :
              {{ dateFromDBTranslatorEN(created_at) }}</span
            >
          </td>
        </tr>
        <tr>
          <td colspan="2">
            สำหรับนักศึกษาระดับ{{ level_name_th }} (<span
              class="english-text"
              >{{ level_name_en }}</span
            >)
          </td>
          <td align="left">
            เลขที่สมัคร&nbsp;<span class="english-text">(Registration No.)</span
            >&nbsp;&nbsp;{{ registId }}
          </td>
        </tr>
        <tr>
          <td colspan="2" align="left">
            เลขบัตรประชาชน&nbsp;<span class="english-text"
              >(ID card number)</span
            >&nbsp;&nbsp;{{ Citizen_id }}
          </td>
          <td align="left" colspan="2">
            ชื่อ – สกุล&nbsp;<span class="english-text">(Name-Surname)</span
            >&nbsp;&nbsp;{{ UserInfo_nameTh + " " + UserInfo_surnameTh }}
          </td>
        </tr>
        <tr>
          <td colspan="2" align="left">
            รอบ&nbsp;<span class="english-text">(Round)</span>&nbsp;&nbsp;{{
              round
            }}
          </td>
          <td colspan="2" align="left">
            โครงการ&nbsp;<span class="english-text">(Project)</span
            >&nbsp;&nbsp;{{ project }}
          </td>
        </tr>
        <tr>
          <td height="5"></td>
        </tr>
      </table>

      <!-- ตารางที่สมัคร -->
      <table class="center cell">
        <tr>
          <td width="7%">
            ลำดับที่เลือก
            <br />
            No.
          </td>
          <td width="20%">
            คณะ
            <br />
            Faculty
          </td>
          <td width="73%">
            หลักสูตร
            <br />
            Curriculum
          </td>
        </tr>

        <tr
          v-for="(item, index) in register_curriculum"
          :key="index"
          class=" ml-5 mb-3"
        >
          <td>{{ index + 1 }}</td>
          <td align="left">
            {{ item.faculty_name_th }}<br />
            <span class="english-text"> {{ item.faculty_name_en }}</span>
            <br />
          </td>
          <td align="left">
            {{ item.curriculum_name_th }}
            <span v-if="item.branch_name_th"
              >แขนง {{ item.branch_name_th }}</span
            >
            <br />
            <span class="english-text">
              {{ item.curriculum_name_en }}
              <span v-if="item.branch_name_th"
                >| Branch : {{ item.branch_name_en }}</span
              >
            </span>
            <br />
          </td>
        </tr>
      </table>

      <br />
      <!--คะแนนมาตรฐานของผู้สมัคร-->
      <table class="center cell" v-if="standard_gat_pat">
        <tr bgcolor="#E0E0E0">
          <td width="100%" colspan="10" align="left">
            คะแนนมาตรฐานของผู้สมัคร
          </td>
        </tr>
        <tr bgcolor="#E0E0E0">
          <td width="10%">
            สอบครั้งที่/ปี
          </td>
          <td width="10%">
            GAT
          </td>
          <td width="10%">
            GAT1
          </td>
          <td width="10%">
            GAT2
          </td>
          <td width="10%">
            PAT1
          </td>
          <td width="10%">
            PAT2
          </td>
          <td width="10%">
            PAT3
          </td>
          <td width="10%">
            PAT4
          </td>
          <td width="10%">
            PAT5
          </td>
          <td width="10%">
            PAT6
          </td>
        </tr>

        <tr
          v-for="(item, index) in standard_gat_pat"
          :key="index"
          class=" ml-5 mb-3"
        >
          <td>{{ item.TEST_ROUND }}/{{ item.TEST_YEAR }}</td>
          <td>
            {{ item.STANDARD_GAT_SCORE }}
          </td>
          <td>
            {{ item.STANDARD_GAT_1_SCORE }}
          </td>
          <td>
            {{ item.STANDARD_GAT_2_SCORE }}
          </td>
          <td>
            {{ item.STANDARD_PAT_1_SCORE }}
          </td>
          <td>
            {{ item.STANDARD_PAT_2_SCORE }}
          </td>
          <td>
            {{ item.STANDARD_PAT_3_SCORE }}
          </td>
          <td>
            {{ item.STANDARD_PAT_4_SCORE }}
          </td>
          <td>
            {{ item.STANDARD_PAT_5_SCORE }}
          </td>
          <td>
            {{ item.STANDARD_PAT_6_SCORE }}
          </td>
        </tr>
      </table>

      <!--คะแนนดิบของผู้สมัคร-->
      <table class="center cell" v-if="raw_gat_pat">
        <tr bgcolor="#E0E0E0">
          <td width="100%" colspan="10" align="left">
            คะแนนดิบของผู้สมัคร
          </td>
        </tr>
        <tr bgcolor="#E0E0E0">
          <td width="10%">
            สอบครั้งที่/ปี
          </td>
          <td width="10%">
            GAT
          </td>
          <td width="10%">
            GAT1
          </td>
          <td width="10%">
            GAT2
          </td>
          <td width="10%">
            PAT1
          </td>
          <td width="10%">
            PAT2
          </td>
          <td width="10%">
            PAT3
          </td>
          <td width="10%">
            PAT4
          </td>
          <td width="10%">
            PAT5
          </td>
          <td width="10%">
            PAT6
          </td>
        </tr>

        <tr
          v-for="(item, index) in raw_gat_pat"
          :key="index"
          class=" ml-5 mb-3"
        >
          <td>{{ item.TEST_ROUND }}/{{ item.TEST_YEAR }}</td>
          <td>
            {{ item.RAW_GAT_SCORE }}
          </td>
          <td>
            {{ item.RAW_GAT_1_SCORE }}
          </td>
          <td>
            {{ item.RAW_GAT_2_SCORE }}
          </td>
          <td>
            {{ item.RAW_PAT_1_SCORE }}
          </td>
          <td>
            {{ item.RAW_PAT_2_SCORE }}
          </td>
          <td>
            {{ item.RAW_PAT_3_SCORE }}
          </td>
          <td>
            {{ item.RAW_PAT_4_SCORE }}
          </td>
          <td>
            {{ item.RAW_PAT_5_SCORE }}
          </td>
          <td>
            {{ item.RAW_PAT_6_SCORE }}
          </td>
        </tr>
      </table>

      <br />
      <!-- ข้อมูลผู้สมัคร -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ข้อมูลผู้สมัคร
            <span class="english-text">(Applicant Information)</span>
          </td>
        </tr>
        <tr>
          <td align="left" width="50%">
            สัญชาติ <span class="english-text">(Nation)</span> : {{ nation }}
          </td>
          <td align="left" width="50%">
            วันเดือนปีเกิด <span class="english-text">(Birthday)</span> :
            {{ dateFromDBTranslatorTH(birthday) }}
          </td>
        </tr>
        <tr>
          <td align="left">Email : {{ email }}</td>
          <td align="left">
            เบอร์โทร <span class="english-text">(Mobile)</span> : {{ mobile }}
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            ที่อยู่ <span class="english-text">(Address)</span> : {{ address }}
          </td>
        </tr>
      </table>

      <!-- ประวัติการศึกษา -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ประวัติการศึกษา
            <span class="english-text">(School Information)</span>
          </td>
        </tr>
        <tr>
          <td align="left" width="50%">
            สถานะการศึกษา
            <span class="english-text">(Educational Status)</span> :
            {{ study_status }}
          </td>
          <td align="left" width="50%">
            ประเภทการศึกษา <span class="english-text">(Study type)</span> :
            {{ study_type }}
          </td>
        </tr>
        <tr>
          <td align="left">
            โรงเรียน <span class="english-text">(School)</span> :
            {{ school_name }}
          </td>
          <td align="left">
            แผนการศึกษา <span class="english-text">(Education Type)</span> :
            {{ education_type }}
          </td>
        </tr>
        <tr>
          <td align="left">
            จำนวนเทอมของ GPA
            <span class="english-text">(Number of GPA terms)</span> :
            {{ term_of_gpa }}
          </td>
          <td align="left">GPA : {{ gpa }}</td>
        </tr>
      </table>

      <!-- เหตุผลในการเข้าศึกษา สจล. -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            เหตุผลในการเข้าศึกษา สจล.
            <span class="english-text"
              >(Reasons for admission to the KMITL)</span
            >
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">{{ userDetail_1 }}</td>
        </tr>
      </table>

      <!-- ความสามารถพิเศษด้านภาษาอังกฤษ -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ความสามารถพิเศษด้านภาษาอังกฤษ
            <span class="english-text"
              >(English language proficiency skill)</span
            >
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            {{ userDetail_2 }}
          </td>
        </tr>
      </table>

      <!-- ความสามารถพิเศษ -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ความสามารถพิเศษ
            <span class="english-text">(Special Qualifications)</span>
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            {{ userDetail_3 }}
          </td>
        </tr>
      </table>

      <!-- ประวัติการได้ทุน -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ประวัติการได้ทุน
            <span class="english-text"
              >(Scholarships that have been received)</span
            >
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            {{ userDetail_4 }}
          </td>
        </tr>
      </table>

      <!-- ประวัติการแข่งกีฬา -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ประวัติการแข่งกีฬา
            <span class="english-text">(Sports competition)</span>
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            {{ userDetail_5 }}
          </td>
        </tr>
      </table>

      <!-- ประวัติการอบรม / แข่งขัน / สอวน. -->
      <table class="center cell">
        <tr bgcolor="#E0E0E0">
          <td align="left" colspan="2">
            ประวัติการอบรม / แข่งขัน / สอวน.
            <span class="english-text"
              >(Training / Competition / Academic Olympiads Camp)</span
            >
          </td>
        </tr>
        <tr>
          <td align="left" colspan="2">
            {{ userDetail_6 }}
          </td>
        </tr>
      </table>

      <table class="center">
        <tr>
          <td align="right">
            <span class="english-text">
              พิมพ์เมื่อวันที่ : {{ timestamp }}</span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import authfoProvider from "@/services/auth.provider";
import refProvider from "@/services/ref.provider";
import payInSlipProvider from "@/services/pay_in_slip.provider";
import ApplicantInfoProvider from "@/services/applicant_info";
import {
  dateFromDBTranslatorTH,
  dateFromDBTranslatorEN,
} from "@/helper/translator";
import { is_student } from "@/router/acl";
const authService = new authfoProvider();
const payInSlipService = new payInSlipProvider();
const refService = new refProvider();
const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "scbSlip",
  props: ["register_id"],
  data: () => ({
    UID: null,

    UserInfo_nameTh: null,
    UserInfo_surnameTh: null,
    Citizen_id: null,
    mobile: null,
    email: null,
    nation: null,
    birthday: null,

    school_name: null,
    study_status: null,
    education_status: null,
    education_type: null,
    study_type: null,
    term_of_gpa: null,
    gpa: null,

    registId: null,
    project: null,
    endApplicationPayDate1: null,
    round: null,
    level_name_th: null,
    level_name_en: null,
    register_curriculum: null,
    created_at: null,

    address: null,
    userDetail_1: null,
    userDetail_2: null,
    userDetail_3: null,
    userDetail_4: null,
    userDetail_5: null,
    userDetail_6: null,
    userDetail_7: null,
    standard_gat_pat: null,
    raw_gat_pat: null,

    timestamp: "",
  }),
  components: {
    // barcode: VueBarcode,
  },
  methods: {
    dateFromDBTranslatorTH,
    dateFromDBTranslatorEN,
    is_student,
    async fetch_data(UID) {
      // ข้อมูลผู้สมัคร
      const dataUserInfo = await authService.getUserInfo(UID);
      this.UserInfo_nameTh = dataUserInfo.admission.STUDENT_FNAME_TH;
      this.UserInfo_surnameTh = dataUserInfo.admission.STUDENT_LNAME_TH;
      this.Citizen_id = dataUserInfo.admission.CITIZEN_ID;
      this.mobile = dataUserInfo.admission.MOBILE;
      this.birthday = dataUserInfo.admission.BIRTHDAY;
      this.email = dataUserInfo.admission.EMAIL;
      this.prefix_name_id = dataUserInfo.admission.PREFIX_NAME_ID;
      // สัญชาติ
      if (dataUserInfo.admission.NATION_ID) {
        const dataNation = await refService.getNationById(
          dataUserInfo.admission.NATION_ID
        );
        this.nation = dataNation[0].NATION_NAME_TH;
      }

      // ข้อมูลการศึกษา (โรงเรียน)
      const dataEducation = await applicantInfoService.getApplicantInfoSchool(
        UID
      );
      this.school_type_id = dataEducation.SCHOOL_TYPE_ID;
      this.study_type_id = dataEducation.STUDY_TYPE_ID;
      this.term_of_gpa = dataEducation.TERM_OF_GPA;
      this.gpa = dataEducation.GPA;
      // ชื่อ รร.
      if (dataEducation.COUNTRY_ID_OF_SCHOOL === "TH") {
        const dataSchool = await refService.getRegistrarSchoolById(
          dataEducation.SCHOOL_ID
        );
        this.school_name = dataSchool[0].SCHOOL_NAME;
      } else {
        this.school_name = dataEducation.SCHOOL_NAME;
      }
      // โปรแกรมการศึกษา
      const dataEducationType = await refService.getEducationTypeById(
        dataEducation.EDUCATION_TYPE_ID
      );
      this.education_type = dataEducationType[0].EDUCATION_TYPE_NAME_TH;
      // สถานะทางการศึกษา
      const dataSchoolStudyStatus = await refService.getSchoolStudyStatusById(
        dataEducation.STUDY_STATUS_ID
      );
      this.study_status = dataSchoolStudyStatus[0].SCHOOL_STUDY_STATUS_NAME_TH;
      // ประเภทการศึกษา
      const dataSchoolStudyType = await refService.getSchoolStudyTypeById(
        dataEducation.STUDY_TYPE_ID
      );
      this.study_type = dataSchoolStudyType[0].SCHOOL_STUDY_TYPE_NAME_TH;
      // ข้อมูลหลักสูตรที่สมัคร
      const dataApplication = await payInSlipService.getPaymentApplicationFee(
        parseInt(this.register_id)
      );
      this.created_at = dataApplication.created_at.substring(0, 10);
      this.registId = dataApplication.register_id;
      this.project = dataApplication.project_name_th;
      this.round = dataApplication.round_name_th;
      this.level_name_th = dataApplication.level_name_th;
      this.level_name_en = dataApplication.level_name_en;
      this.register_curriculum = dataApplication.register_curriculum;
      // ข้อมูลเพิ่มเติม
      const dataUserDetail = await applicantInfoService.getApplicantInfoAdditionalUndergraduate(
        UID
      );
      this.address = dataUserDetail.ADDRESS;
      this.userDetail_1 = dataUserDetail.USER_DETAIL_1;
      this.userDetail_2 = dataUserDetail.USER_DETAIL_2;
      this.userDetail_3 = dataUserDetail.USER_DETAIL_3;
      this.userDetail_4 = dataUserDetail.USER_DETAIL_4;
      this.userDetail_5 = dataUserDetail.USER_DETAIL_5;
      this.userDetail_6 = dataUserDetail.USER_DETAIL_6;
      this.userDetail_7 = dataUserDetail.USER_DETAIL_7;
      this.standard_gat_pat = dataUserDetail.standard_gat_pat;
      this.raw_gat_pat = dataUserDetail.raw_gat_pat;
    },

    getNow: function() {
      const today = new Date();
      const date = dateFromDBTranslatorTH(today);
      const time =
        today.getHours() +
        ":" +
        (today.getMinutes() < 10 ? "0" : "") +
        today.getMinutes() +
        ":" +
        (today.getSeconds() < 10 ? "0" : "") +
        today.getSeconds();
      const dateTime = date + " " + time;
      this.timestamp = dateTime;
    },
    createPDF() {
      var sTable = document.getElementById("tab").innerHTML;

      var style = "<style>";
      style =
        style +
        "@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');";
      style = style + "body{font-family: 'Sarabun', sans-serif;}";
      style = style + "ul {list-style-type: none; padding: 0;}";
      style = style + "li {display: inline-block; margin: 0 10px;}";
      style = style + "a {color: #42b983;}";
      style = style + "u {text-decoration: underline;}";
      style =
        style + "span1 {border-bottom:solid black 1px; padding-right:10rem;}";
      style = style + "table {width:100%;}";
      style =
        style +
        "table, th, td, tr {table-layout: fixed; overflow: hidden; padding: 2px 3px;}";
      style =
        style +
        "table.center {width:100%; margin-left : auto; margin-right : auto; font-size: 12px;}";
      style =
        style +
        ".cell {vertical-align : middle; text-align : center; width : 100%; border-collapse: collapse;";
      style =
        style + "border-top: double; border-top-width: 4px; font-size:12px;}";
      style =
        style + ".cell th {border:1px solid #C0C0C0; background:#F0F0F0;}";
      style =
        style +
        ".cell td {border:1px solid #C0C0C0; vertical-align:top; padding: 2px 4px;}";
      style =
        style +
        ".cell-total {vertical-align:middle; text-align:center; width:100%; ";
      style = style + "border-collapse:collapse; font-size:11px;}";
      style =
        style +
        ".cell-total th {border:1px solid #C0C0C0; background:#F0F0F0; font-size: 11px;}";
      style =
        style +
        ".cell-total td {border:1px solid #C0C0C0; vertical-align: top; ";
      style = style + "padding: 2px 4px; font-size: 11px;}";
      style =
        style +
        ".notice-box {padding: 10px 10px 10px 10px; outline-style: solid; outline-color: silver;";
      style =
        style + "outline-width: 1px; outline-offset: -10px; text-align: left;}";
      style = style + ".notice-box1 {text-align: center; color: red;}";
      style = style + ".tab1 {padding-left: 2em;}";
      style = style + ".mini-font-right {font-size: 11px; text-align: right;}";
      style = style + ".mini-font-left {font-size: 9px; text-align: left;}";
      style = style + ".mini-font {font-size: 11px; text-align: center;}";
      style = style + ".seperate-page {font-size: 8px; text-align: center;}";
      style =
        style + ".bigger-mini-font-right {font-size: 12px; text-align: right;}";
      style =
        style + ".bigger-mini-font-left {font-size: 12px; text-align: left;}";
      style =
        style +
        ".sub-table {width : 40%; border-collapse: collapse; border: 1px solid gray;}";
      style =
        style +
        ".english-text {color: #696969; padding-top: -2em; font-size: 9px}";
      style = style + "</style>";

      // CREATE A WINDOW OBJECT.
      // var win = window.open('', '', 'height=700,width=700');
      var win = window.open("", "");

      win.document.write("<html><head>");
      win.document.write("<title>ใบสมัครสอบ สจล.</title>"); // <title> FOR PDF HEADER.
      win.document.write(style); // ADD STYLE INSIDE THE HEAD TAG.
      win.document.write("</head>");
      win.document.write("<body>");
      win.document.write(sTable); // THE TABLE CONTENTS INSIDE THE BODY TAG.
      win.document.write("</body></html>");

      // win.close(); // CLOSE THE CURRENT WINDOW.

      setTimeout(function() {
        win.print();
      }, 100); // PRINT THE CONTENTS.
    },
  },

  created() {
    const url_data = this.$route.query;
    this.fetch_data(url_data.uid);
    setInterval(this.getNow, 1000);
  },
};
</script>

<style scoped>
.svg-container {
  width: 80%;
}
body {
  width: 90%;
  margin: auto;
  font-family: "Sarabun", sans-serif;
  font-size: 13px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
u {
  text-decoration: underline;
}
/* p {
            border-bottom: solid white 1px;
        } */
.span1 {
  border-bottom: solid black 1px;
  padding-right: 5rem;
}

/* table */
table,
th,
td,
tr {
  table-layout: fixed;
  overflow: hidden;
}
table.center {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.cell {
  vertical-align: middle;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  border-top: double;
  border-top-width: 4px;
  font-size: 12px;
}
.cell th {
  border: 1px solid #c0c0c0;
  background: #f0f0f0;
}
.cell td {
  border: 1px solid #c0c0c0;
  vertical-align: top;
  padding: 2px 4px;
}

.cell-total {
  vertical-align: middle;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}
.cell-total th {
  border: 1px solid #c0c0c0;
  background: #f0f0f0;
  font-size: 11px;
}
.cell-total td {
  border: 1px solid #c0c0c0;
  vertical-align: top;
  padding: 2px 4px;
  font-size: 11px;
}

.notice-box {
  padding: 10px 10px 10px 10px;
  outline-style: solid;
  outline-color: silver;
  outline-width: 1px;
  outline-offset: -10px;
  text-align: left;
}

.notice-box1 {
  text-align: center;
  color: red;
}

.tab1 {
  padding-left: 2em;
}

.mini-font-right {
  font-size: 11px;
  text-align: right;
}
.mini-font-left {
  font-size: 9px;
  text-align: left;
}
.mini-font {
  font-size: 11px;
  text-align: center;
}

.seperate-page {
  font-size: 8px;
  text-align: center;
}

.bigger-mini-font-right {
  font-size: 12px;
  text-align: right;
}
.bigger-mini-font-left {
  font-size: 12px;
  text-align: left;
}

.sub-table {
  width: 22%;
  border-collapse: collapse;
  border: 1px solid gray;
}

.english-text {
  color: #696969;
  padding-top: -2em;
}

.button {
  border-radius: 36px;
  background-color: #ffc107;
  border: none;
  color: #ffffff;
  text-align: center;
  font-size: 28px;
  padding: 15px;
  width: 100%;
  transition: all 0.3s;
  cursor: pointer;
}
/* .button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.3s;
}
.button span:after {
  content: "<< CLICK >>";
  font-size: 16px;
  position: relative;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.3s;
}
.button:hover span {
  padding-right: 100px;
}
.button:hover span:after {
  opacity: 1;
  right: 0;
} */
</style>
